module.exports = __webpack_public_path__ + "img/95.052f2709.webp";